import React from 'react';
import { Link } from 'react-router-dom';

const CustomSlide3 = ({children, className = ''}) => {
    return (
        <section className={`ps-custom-slide3 ${className}`.trim()} aria-labelledby="ps-custom-slide3-title">
            <div className="ps-custom-slide3__shell">
                <div className="ps-custom-slide3__content">
                    <h2 className="ps-custom-slide3__title" id="ps-custom-slide3-title">
                        Rooted in Tradition.
                        <br />
                        Committed to Purity.
                    </h2>

                    <div className="ps-custom-slide3__divider" aria-hidden="true">
                        <span className="ps-custom-slide3__line" />
                        <span className="ps-custom-slide3__leafWrap">
                            <img src="/assets/img/leaf-2.png" alt="" className="ps-custom-slide3__leaf" />
                        </span>
                        <span className="ps-custom-slide3__line" />
                    </div>

                    <p className="ps-custom-slide3__copy">
                        At Nature Way, we believe that the best things in life are pure, simple, and natural. Our oils are crafted using
                        traditional wood-pressed methods to bring you the true essence of nature.
                    </p>

                    <Link className="ps-custom-slide3__button" to="/aboutus">
                        <span className="ps-custom-slide3__buttonIcon" aria-hidden="true">
                            ❧
                        </span>
                        <span>Know Our Story</span>
                        <span className="ps-custom-slide3__buttonArrow" aria-hidden="true">
                            →
                        </span>
                    </Link>
                </div>

                <div className="ps-custom-slide3__visual" aria-hidden="true">
                    <div className="ps-custom-slide3__imageFrame">
                        <img
                            src="/assets/img/custom_comp2_image.png"
                            alt=""
                            className="ps-custom-slide3__image"
                            style={{
                                borderRadius: 0,
                            }}
                        />
                    </div>
                </div>
            </div>

            {children ? <div className="ps-custom-slide3__children">{children}</div> : null}
        </section>
    );
};

export default CustomSlide3;
